<template>
	<div class="px-3 width-100 height-100 marketplace-container pb-8">
		<div class="page-title-text mt-9">{{ pageTitle }}</div>
		<FlowsView :filter-by="filterBy" class="pb-8" />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import FlowsView from '@/views/AppContentPages/FlowsView.vue';
import { getAccountConnection } from '@/store/modules/credentials/getters';
export default {
	name: 'ConnectionFeatures',
	props: {
		serviceID: { type: String },
		placementType: { type: String },
		serviceWorkspaceID: { type: String },
	},
	components: {
		FlowsView,
	},
	computed: {
		...mapGetters([getAccountConnection.fullPath]),
		connection() {
			return this[getAccountConnection.fullPath](this.serviceWorkspaceID) || {};
		},
		pageTitle() {
			return this.isAddOnMode ? 'Add-ons' : 'Tools';
		},
		isAddOnMode() {
			return Boolean(this.serviceWorkspaceID);
		},
		filterBy() {
			if (this.isAddOnMode) {
				return { service_workspace: this.serviceWorkspaceID, service: this.serviceID };
			} else {
				return { workflow_type: this.placementType };
			}
		},
	},
	watch: {},
	methods: {},
};
</script>

<style scoped lang="scss">
.page-title-text {
	font-size: 22px;
	font-weight: 600;
	color: #4d4c52;
}
</style>
